module.exports = __webpack_public_path__ + "static/img/usinessPartner_03.71cf0c14.jpg";